export const DEFAULT_PANEL_COLOR = {
    TOP_PANEL_COLOR: '#0570A1',
    SETTING_COLOR: '#FFFFFF',
    SETTING_ACTIVE_COLOR: '#067BBD',
    SETTING_ACTIVE_BG_COLOR: '#FFFFFF',
};
